import { useState, useEffect, useCallback } from 'react';
import { useSpringCarousel } from 'react-spring-carousel';

export function Carousel() {
  const [itemsPerSlide, setItemsPerSlide] = useState(1);

  // Case study items
  const caseStudies = [
    { id: 1, image: 'с1.png', title: 'Living room concept' },
    { id: 2, image: 'с2.png', title: 'Bedroom concept' },
    { id: 3, image: 'с3.png', title: 'Living room concept' },
    { id: 4, image: 'с4.png', title: 'Bedroom concept' },
  ];

  // Handle responsive items per slide
  const updateItemsPerSlide = useCallback(() => {
    const width = window.innerWidth;
    setItemsPerSlide(width < 768 ? 1 : 2);
  }, []);

  // Initialize and handle window resize
  useEffect(() => {
    updateItemsPerSlide();

    const handleResize = () => {
      updateItemsPerSlide();
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [updateItemsPerSlide]);

  // Configure carousel with current itemsPerSlide value
  const { carouselFragment, slideToNextItem } = useSpringCarousel({
    withLoop: true,
    itemsPerSlide: itemsPerSlide,
    items: caseStudies.map((item) => ({
      id: item.id,
      renderItem: (
        <div className="w-full px-2 sm:px-4 md:px-7">
          <div className="relative">
            <img
              src={item.image}
              className="w-full rounded-xl border-2 border-primary-primary-50"
              draggable={false}
              onContextMenu={(e) => e.preventDefault()}
              style={{ cursor: 'grab' }}
              alt={item.title}
              loading="lazy"
            />
            <div className="absolute bottom-0 left-0 flex w-full items-start justify-start p-4">
              <div className="text-base font-bold text-neutral-neutral-00 sm:text-lg md:text-xl">
                {item.title}
              </div>
            </div>
          </div>
        </div>
      ),
    })),
  });

  // Auto-advance carousel
  useEffect(() => {
    const timer = setInterval(() => {
      slideToNextItem();
    }, 10000);

    return () => {
      clearInterval(timer);
    };
  }, [slideToNextItem]);

  return <div className="w-full">{carouselFragment}</div>;
}

export default Carousel;
